import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Landing_temp from "../components/Landing_temp";

export default withRouter(connect()(Landing_temp));
